// src/lib/kinema/core/layers/LayerTypeRegistry.ts
import type { LayerTypeDefinition } from '../types';

export class LayerTypeRegistry {
  private types = new Map<string, LayerTypeDefinition>();

  register(definition: LayerTypeDefinition): void {
    this.types.set(definition.type, definition);
  }

  get(type: string): LayerTypeDefinition | undefined {
    return this.types.get(type);
  }

  has(type: string): boolean {
    return this.types.has(type);
  }

  getDefaults(type: string): Record<string, any> {
    const def = this.types.get(type);
    if (!def) return {};
    const defaults: Record<string, any> = {};
    for (const [key, prop] of Object.entries(def.properties)) {
      defaults[key] = prop.default;
    }
    return defaults;
  }

  getAllTypes(): string[] {
    return Array.from(this.types.keys());
  }
}
